function debounce(func, wait) {
  let timeout;
  return function executedFunction(...args) {
    const later = () => {
      clearTimeout(timeout);
      func(...args);
    };
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
  };
}

const handleInput = debounce((e) => {
  setTimeout(() => BSS_B2B.cp.changeProductPrice(BSS_B2B.shopData, false, false), 300);
}, 300);

$("[data-predictive-search-input]").on("input", handleInput);
